import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * When a listUsers request is made, attempts to execute the API request,
 * and send out the appropriate success or error action afterwards
 */
export const getUsersOnRequest = store.effects.create((feature: Feature) =>
  feature.actions.listUsers.request.observe().pipe(
    rxjs.mergeMap(action => {
      const { filters } = action.data
      const userList$ = feature.api.listUsers(filters)
      return userList$.pipe(
        rxjs.map(users =>
          feature.actions.listUsers.success.from(action).create({
            request: action.data,
            response: {
              users,
            },
          }),
        ),
        rxjs.catchError(error =>
          rxjs.of(
            feature.actions.listUsers.error.from(action).create({
              error,
              request: action.data,
            }),
          ),
        ),
      )
    }),
  ),
)
